var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.0 8.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_up_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_up_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L12,6 L10.59,7.41 L6,2.83 L1.41,7.41 L0,6 L6,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40.0 -1365.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow_up_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.0 1357.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.0 8.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow_up_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 12,0 12,7.41 0,7.41 0,0",
    stroke: "none"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.c47dec5d19cc94d0118aed9e594605d0.svg";
export { ForwardRef as ReactComponent };